/**
 * assets/Vshade.js
 * Colle ce fichier tel quel dans assets/. Aucun build requis.
 * Contient : data (tables du doc) + moteur de décision + logique UI du quiz.
 * Le catalogue produit (handles/variant IDs réels) est en bas — À REMPLIR.
 */
(function () {
  "use strict";

  var LANG = ((window.VGlowLocale || document.documentElement.lang || "en").toLowerCase().indexOf("fr") === 0) ? "fr" : "en";
  var CANONICAL_VARIANTS = {"blush-a":[{"id":43970962030905,"title":"Default Title"}],"blush-b":[{"id":43970956624185,"title":"Default Title"}],"blush-c":[{"id":43970962620729,"title":"Default Title"}],"blush-d":[{"id":43970960556345,"title":"Default Title"}],"blush-e":[{"id":43970957214009,"title":"Default Title"}],"blush-f":[{"id":43970963603769,"title":"Default Title"}],"blush-g":[{"id":43970959147321,"title":"Default Title"}],"spot-light-strobing-a":[{"id":43971002728761,"title":"Default Title"}],"spot-light-strobing-b":[{"id":43971003121977,"title":"Default Title"}],"spot-light-strobing-c":[{"id":43971002564921,"title":"Default Title"}],"spot-light-strobing-d":[{"id":43971003515193,"title":"Default Title"}],"spot-light-strobing-e":[{"id":43971004301625,"title":"Default Title"}],"eyeshadow-blush-palette":[{"id":43970806448441,"title":"Default Title"}],"eyeshadow-blush-palette-d":[{"id":43970806841657,"title":"Default Title"}],"creamy-liquid-lipstick":[{"id":50110542905657,"title":"Aioli"},{"id":49394264703289,"title":"Bubbly"},{"id":49394264768825,"title":"Deep Desire"},{"id":49394264899897,"title":"Drama Kween"},{"id":49394264965433,"title":"Emotion"},{"id":49394264801593,"title":"Extatik"},{"id":49394264539449,"title":"Faith"},{"id":49394264834361,"title":"Feel Good"},{"id":49394264736057,"title":"Good Mood"},{"id":49394264506681,"title":"Happiness"},{"id":49394264572217,"title":"Hope"},{"id":49394264375609,"title":"Katwalk"},{"id":49394264670521,"title":"Life"},{"id":49394264473913,"title":"Namaste"},{"id":49394264342841,"title":"Pink Light"},{"id":49394264932665,"title":"Rich Bronze"},{"id":49394264441145,"title":"Sleep"},{"id":49394264604985,"title":"Sunrise"},{"id":49394264637753,"title":"Sweet Love"},{"id":49394264310073,"title":"Thunderstorm"}],"long-lasting-lipgloss":[{"id":49394306515257,"title":"Awake"},{"id":49394306744633,"title":"Big Hug"},{"id":49394306711865,"title":"Café Au Lait"},{"id":50146361573689,"title":"Cocoskin"},{"id":49394306646329,"title":"Crisis"},{"id":49394306482489,"title":"Dark Mind"},{"id":49394306416953,"title":"Ékla"},{"id":49394306679097,"title":"Flawless"},{"id":49394306580793,"title":"Klash"},{"id":49394306449721,"title":"Narcist"},{"id":49394306613561,"title":"Nev-Rosé"},{"id":49394306548025,"title":"Therapy"},{"id":49394306384185,"title":"Wisdom"}],"intense-lacquer":[{"id":49395275432249,"title":"Lovely"},{"id":49395275465017,"title":"Kutipie"},{"id":49395275497785,"title":"Josefine"},{"id":49395275530553,"title":"Compassionate"},{"id":49395275563321,"title":"Kind"},{"id":49395275596089,"title":"Sacha"},{"id":49395275628857,"title":"Mal-bek"},{"id":49395275661625,"title":"Hot-Passion"},{"id":49395275694393,"title":"Confident"},{"id":49395275727161,"title":"Laughter"},{"id":49395275759929,"title":"Unity"}],"concealer-pot":[{"id":49395283165497,"title":"C3 Warm Yellow"},{"id":49395283132729,"title":"C4 Warm Yellow"},{"id":49395283099961,"title":"C5 Warm Yellow"},{"id":49395283034425,"title":"C6 Warm Yellow"},{"id":49395283001657,"title":"C7 Warm Yellow"},{"id":49395282968889,"title":"C8 Warm Yellow"},{"id":49395282903353,"title":"C9 Warm Yellow"},{"id":49395282870585,"title":"C10 Warm Yellow"},{"id":49395282837817,"title":"C11 Warm Yellow"},{"id":49395283198265,"title":"C25 Warm Yellow"},{"id":49395283067193,"title":"C57 Warm Yellow"},{"id":49395282936121,"title":"C85 Warm Yellow"}],"bb-cream":[{"id":49395284934969,"title":"Fair"},{"id":49395284902201,"title":"Light"},{"id":49395284869433,"title":"Light Medium"},{"id":49395284836665,"title":"Medium"},{"id":49395284803897,"title":"Dark"}],"hi-def-foundation":[{"id":49395287425337,"title":"C6 Warm Yellow"},{"id":49395287359801,"title":"C10 Warm Yellow"},{"id":49395287327033,"title":"C11 Warm Yellow"},{"id":49395287490873,"title":"C25 Warm Yellow"},{"id":49395287458105,"title":"C45 Warm Yellow"},{"id":49395287392569,"title":"C95 Warm Yellow"},{"id":49395287163193,"title":"N10 Cool Neutral"},{"id":49395287130425,"title":"N11 Cool Neutral"},{"id":49395287294265,"title":"N25 Cool Neutral"},{"id":49395287261497,"title":"N45 Cool Neutral"},{"id":49395287228729,"title":"N75 Cool Neutral"},{"id":49395287195961,"title":"N95 Cool Neutral"}],"mousse-foundation":[{"id":49395290014009,"title":"N9 COOL NEUTRAL"},{"id":49395290046777,"title":"N7 COOL NEUTRAL"},{"id":49395290079545,"title":"N5 COOL NEUTRAL"},{"id":49395290112313,"title":"N4 COOL NEUTRAL"},{"id":49395290145081,"title":"N25 COOL NEUTRAL"},{"id":49395290177849,"title":"C7 WARM YELLOW"},{"id":49395290210617,"title":"C6 WARM YELLOW"},{"id":49395290243385,"title":"C4 WARM YELLOW"},{"id":49395290276153,"title":"C3 WARM YELLOW"},{"id":49395290308921,"title":"C2 WARM YELLOW"}],"cream-foundation":[{"id":49395303219513,"title":"C7 Warm Yellow"},{"id":49395303186745,"title":"C8 Warm Yellow"},{"id":49395303121209,"title":"C10 Warm Yellow"},{"id":49395303088441,"title":"C11 Warm Yellow"},{"id":49395303153977,"title":"C85 Warm Yellow"},{"id":49395303055673,"title":"N8 Cool Neutral"},{"id":49395302990137,"title":"N10 Cool Neutral"},{"id":49395302957369,"title":"N11 Cool Neutral"},{"id":49395302924601,"title":"N14 Cool Neutral"},{"id":49395302891833,"title":"N15 Cool Neutral"},{"id":49395303022905,"title":"N95 Cool Neutral"}],"sheer-glow-illuminating-lotion":[{"id":50136112922937,"title":"Bronze Baby"},{"id":50136110498105,"title":"Flash"},{"id":50136110530873,"title":"Nice Peach"},{"id":50136110563641,"title":"Sweet Dream"}],"under-eye-corrector":[{"id":50146484060473,"title":"Mandarine"},{"id":50146484093241,"title":"Profound Peachy"},{"id":50146484126009,"title":"Peachy"},{"id":50146484158777,"title":"Rose"}]};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var I18N = {
    en: { progress:"Question {n} of {total}", closer:"You're getting closer to your V-Glow.", almost:"Almost there…", back:"← Back", emailTitle:"YOUR V-GLOW IS READY ✨", emailText:"We've analyzed your complexion, undertone, skin needs and beauty style. Enter your email to reveal your personalized V-Glow Profile™ + complete beauty routine.", placeholder:"you@email.com", reveal:"REVEAL MY V-GLOW →", creating:"CREATING YOUR V-GLOW…", matching:"✓ Matching your complexion", reading:"✓ Reading your undertone", goals:"✓ Personalizing your beauty goals", routine:"✓ Building your V Kosmetik routine", add:"Add to cart", adding:"Adding…", profile:"YOUR V-GLOW PROFILE™", family:"YOU ARE THE {profile}™", foundation:"YOUR #1 FOUNDATION MATCH", corrector:"UNDER-EYE CORRECTOR", concealer:"CONCEALER", blush:"BLUSH", glow:"GLOW / HIGHLIGHT", lip:"LIP PRODUCT", kit:"Recommended kit:", offer:"✦ Personalized Offer ✦", headline:"Your ideal routine awaits you", expires:"Your selection expires soon", hours:"Hours", minutes:"Minutes", seconds:"Seconds", off:"OFF", footer:"Your personalized matches are ready — complete your V-GLOW routine now.", routineCTA:"GET MY V-GLOW ROUTINE", helpShade:"Need help confirming my shade", mappingPending:"complementary recommendation — mapping pending", productUnavailable:"product unavailable — choose another routine level", oliveTitle:"LET'S REFINE YOUR OLIVE UNDERTONE", oliveSub:"Which description feels closest to your skin?", oliveGolden:"GOLDEN OLIVE — My skin has an olive cast with noticeable golden warmth.", oliveNeutral:"NEUTRAL OLIVE — My skin looks more muted/neutral than golden or rosy.", oliveSure:"I'M NOT SURE — Help me choose." },
    fr: { progress:"Question {n} sur {total}", closer:"Vous vous rapprochez de votre V-Glow.", almost:"Presque terminé…", back:"← Retour", emailTitle:"VOTRE V-GLOW EST PRÊT ✨", emailText:"Nous avons analysé votre teint, votre sous-ton, les besoins de votre peau et votre style beauté. Entrez votre e-mail pour découvrir votre Profil V-Glow™ personnalisé + votre routine beauté complète.", placeholder:"vous@email.com", reveal:"RÉVÉLER MON V-GLOW →", creating:"CRÉATION DE VOTRE V-GLOW…", matching:"✓ Analyse de votre teint", reading:"✓ Analyse de votre sous-ton", goals:"✓ Personnalisation de vos objectifs beauté", routine:"✓ Création de votre routine V Kosmetik", add:"Ajouter au panier", adding:"Ajout…", profile:"VOTRE PROFIL V-GLOW™", family:"VOUS ÊTES {profile}™", foundation:"VOTRE MEILLEURE CORRESPONDANCE DE FOND DE TEINT", corrector:"CORRECTEUR CONTOUR DES YEUX", concealer:"ANTI-CERNES", blush:"BLUSH", glow:"ÉCLAT / HIGHLIGHTER", lip:"PRODUIT POUR LES LÈVRES", kit:"Kit recommandé :", offer:"✦ Offre personnalisée ✦", headline:"Votre routine idéale vous attend", expires:"Votre sélection expire bientôt", hours:"Heures", minutes:"Minutes", seconds:"Secondes", off:"DE RÉDUCTION", footer:"Vos recommandations personnalisées sont prêtes — complétez votre routine V-GLOW dès maintenant.", routineCTA:"OBTENIR MA ROUTINE V-GLOW", helpShade:"Besoin d'aide pour confirmer votre teinte", mappingPending:"recommandation complémentaire — correspondance en attente", productUnavailable:"produit indisponible — choisissez un autre niveau de routine", oliveTitle:"AFFINONS VOTRE SOUS-TON OLIVE", oliveSub:"Quelle description correspond le mieux à votre peau ?", oliveGolden:"OLIVE DORÉ — Ma peau a une tonalité olive avec une chaleur dorée bien visible.", oliveNeutral:"OLIVE NEUTRE — Ma peau paraît plus douce/neutre que dorée ou rosée.", oliveSure:"JE NE SAIS PAS" }
  };
  function t(key, vars) { var v=I18N[LANG][key] || I18N.en[key] || key; Object.keys(vars||{}).forEach(function(k){v=v.replace(new RegExp("\\{"+k+"\\}","g"),vars[k]);}); return v; }
  Object.assign(I18N.en, { emailText:"Your personalized recommendations are ready. View them below, or optionally sign up for V Kosmetik news.", emailLabel:"Email (optional)", consent:"I agree to receive V Kosmetik news and offers by email. I can unsubscribe at any time.", privacy:"Privacy policy", added:"Added ✓", error:"Unable to add this item. Please try again.", retry:"Unable to load your recommendations. Please try again.", restart:"Restart quiz", offer:"Your personalized selection", reason:"Recommended from your quiz answers. Confirm your shade on the product page.", details:"View product", productUnavailable:"No available match for this selection. Contact us for help.", mappingPending:"Contact us to confirm a suitable shade." });
  Object.assign(I18N.fr, { emailText:"Vos recommandations personnalisées sont prêtes. Consultez-les ci-dessous ou inscrivez-vous, si vous le souhaitez, aux nouvelles de V Kosmetik.", emailLabel:"Adresse e-mail (facultative)", consent:"J’accepte de recevoir les nouvelles et offres de V Kosmetik par e-mail. Je peux me désabonner à tout moment.", privacy:"Politique de confidentialité", added:"Ajouté ✓", error:"Impossible d’ajouter cet article. Veuillez réessayer.", retry:"Impossible de charger vos recommandations. Veuillez réessayer.", restart:"Recommencer le quiz", offer:"Votre sélection personnalisée", reason:"Recommandé selon vos réponses au quiz. Confirmez votre teinte sur la fiche produit.", details:"Voir le produit", productUnavailable:"Aucune correspondance disponible pour cette sélection. Contactez-nous pour obtenir de l’aide.", mappingPending:"Contactez-nous pour confirmer une teinte adaptée." });
  function display(v) {
    if(typeof v!=="string") return v;
    v=v.trim();
    if(LANG!=="fr") return v;
    var m={
      "WHICH FAMILY FEELS CLOSEST TO YOU?":"QUELLE FAMILLE VOUS CORRESPOND LE MIEUX ?",
      "WHAT\'S YOUR UNDERTONE?":"QUEL EST VOTRE SOUS-TON ?",
      "HOW DEEP IS YOUR SHADE?":"QUELLE EST LA PROFONDEUR DE VOTRE TEINTE ?",
      "WHAT\'S YOUR SKIN TYPE?":"QUEL EST VOTRE TYPE DE PEAU ?",
      "HOW MUCH COVERAGE DO YOU WANT?":"QUEL NIVEAU DE COUVRANCE SOUHAITEZ-VOUS ?",
      "WHAT FINISH DO YOU PREFER?":"QUEL FINI PRÉFÉREZ-VOUS ?",
      "WHAT\'S YOUR MAIN BEAUTY CONCERN?":"QUELLE EST VOTRE PRINCIPALE PRÉOCCUPATION BEAUTÉ ?",
      "WHAT\'S YOUR BEAUTY STYLE?":"QUEL EST VOTRE STYLE BEAUTÉ ?",
      "WHAT\'S YOUR LIP PREFERENCE?":"QUELLE EST VOTRE PRÉFÉRENCE POUR LES LÈVRES ?",
      "Porcelain Kween":"Porcelain Kween",
      "Sandy Muse":"Sandy Muse",
      "Golden Glow":"Golden Glow",
      "Caramel Queen":"Caramel Queen",
      "Deep Ebony":"Deep Ebony",
      "Rich Royalty":"Rich Royalty",
      "Very fair skin, often with freckles or pink undertones":"Peau très claire, souvent avec des taches de rousseur ou des sous-tons rosés",
      "Light to medium skin, sand/neutral beige complexion":"Peau claire à médium, teint beige sable/neutre",
      "Olive or golden skin, bronze easily":"Peau olive ou dorée, bronze facilement",
      "Caramel skin, light black, mixed or Indian skin, warm undertones":"Peau caramel, peau noire claire, métissée ou indienne, avec des sous-tons chauds",
      "Dark, rich, chocolate skin, caramel, light black, mixed or Indian skin, warm undertones":"Peau foncée, riche et chocolatée, caramel, noire claire, métissée ou indienne, avec des sous-tons chauds",
      "Very deep skin, pure ebony with cold or neutral undertones":"Peau très foncée, ébène profond, avec des sous-tons froids ou neutres",
      "Cool/Rosy":"Froid/Rosé","Warm/Golden":"Chaud/Doré","Neutral":"Neutre","I'm Not Sure":"Je ne sais pas",
      "Light":"Légère","True":"Moyenne","Deeper":"Foncée","Medium":"Moyenne","Full":"Totale",
      "Dry":"Sèche","Oily":"Grasse","Combination":"Mixte","Normal":"Normale",
      "Natural":"Naturel","Radiant":"Éclatant","Satin":"Satiné","Soft Matte":"Mat doux","Matte":"Mat",
      "Dark circles":"Cernes","Dull complexion":"Teint terne","Imperfections":"Imperfections","Uneven skin tone":"Teint irrégulier","Shine/oil control":"Contrôle de la brillance","Full glow-up":"Glow-up complet",
      "Natural Everyday":"Naturel au quotidien","NOT SURE — GUIDE ME":"JE NE SAIS PAS","Nude Everyday":"Nude quotidien","Bold Statement":"Audacieux","Surprise Me":"Surprenez-moi"
    };
    return m[v]||v;
  }

  /* ============================================================
   * 1) DATA — tables extraites du doc (sections 4-9)
   * ============================================================ */
  var BLOCK = { NO_CODE: "NO_CODE", DO_NOT_CODE: "DO_NOT_CODE", NO_EXACT_PRIMARY: "NO_EXACT_PRIMARY", OUT_OF_STOCK_KNOWN: "OUT_OF_STOCK_KNOWN" };

  var PRIMARY_SHADE_MAP = {
    "Porcelain Kween|Cool/Rosy|Light": { mousse: "N4", flawless: "N2", cream: BLOCK.NO_EXACT_PRIMARY, hidef: BLOCK.DO_NOT_CODE, bb: "Fair" },
    "Porcelain Kween|Warm/Golden|Light": { mousse: "C2", flawless: "C3", cream: BLOCK.NO_EXACT_PRIMARY, hidef: BLOCK.DO_NOT_CODE, bb: "Fair" },
    "Porcelain Kween|Neutral|Light": { mousse: "N4", flawless: "N3", cream: BLOCK.NO_EXACT_PRIMARY, hidef: BLOCK.DO_NOT_CODE, bb: "Fair" },
    "Porcelain Kween|Olive|any": { mousse: BLOCK.NO_CODE, flawless: BLOCK.NO_CODE, cream: BLOCK.NO_CODE, hidef: BLOCK.DO_NOT_CODE, bb: "Fair" },

    "Sandy Muse|Cool/Rosy|Light": { mousse: "N4", flawless: "N5", cream: BLOCK.NO_EXACT_PRIMARY, hidef: BLOCK.DO_NOT_CODE, bb: BLOCK.OUT_OF_STOCK_KNOWN },
    "Sandy Muse|Warm/Golden|True": { mousse: "C4", flawless: "C4", cream: BLOCK.NO_EXACT_PRIMARY, hidef: BLOCK.DO_NOT_CODE, bb: BLOCK.OUT_OF_STOCK_KNOWN },
    "Sandy Muse|Neutral|True": { mousse: "N5", flawless: "N5", cream: BLOCK.NO_EXACT_PRIMARY, hidef: BLOCK.DO_NOT_CODE, bb: BLOCK.OUT_OF_STOCK_KNOWN },
    "Sandy Muse|Olive|any": { mousse: BLOCK.NO_CODE, flawless: BLOCK.NO_CODE, cream: BLOCK.NO_CODE, hidef: BLOCK.DO_NOT_CODE, bb: "Light" },

    "Golden Glow|Cool/Rosy|True": { mousse: "N7", flawless: "N8", cream: "N8", hidef: BLOCK.DO_NOT_CODE, bb: "Light Medium" },
    "Golden Glow|Warm/Golden|True": { mousse: "C6", flawless: "C6", cream: "C7", hidef: BLOCK.DO_NOT_CODE, bb: "Light Medium" },
    "Golden Glow|Neutral|True": { mousse: "N9", flawless: "N9", cream: "N8", hidef: BLOCK.DO_NOT_CODE, bb: "Light Medium" },
    "Golden Glow|Olive|any": { mousse: BLOCK.NO_CODE, flawless: BLOCK.NO_CODE, cream: BLOCK.NO_CODE, hidef: BLOCK.DO_NOT_CODE, bb: "Light Medium" },

    "Caramel Queen|Cool/Rosy|True": { mousse: BLOCK.NO_EXACT_PRIMARY, flawless: "N10", cream: "N10", hidef: BLOCK.DO_NOT_CODE, bb: "Medium" },
    "Caramel Queen|Warm/Golden|True": { mousse: "C8", flawless: "C8", cream: "C8", hidef: BLOCK.DO_NOT_CODE, bb: "Medium" },
    "Caramel Queen|Neutral|True": { mousse: "C8", flawless: "N10", cream: "N10", hidef: BLOCK.DO_NOT_CODE, bb: "Medium" },
    "Caramel Queen|Olive|any": { mousse: BLOCK.NO_CODE, flawless: BLOCK.NO_CODE, cream: BLOCK.NO_CODE, hidef: BLOCK.DO_NOT_CODE, bb: "Medium" },

    "Deep Ebony|Cool/Rosy|True": { mousse: "N25", flawless: "N25", cream: "N14", hidef: BLOCK.DO_NOT_CODE, bb: "Dark" },
    "Deep Ebony|Warm/Golden|True": { mousse: BLOCK.NO_EXACT_PRIMARY, flawless: "C10", cream: "C10", hidef: BLOCK.DO_NOT_CODE, bb: "Dark" },
    "Deep Ebony|Neutral|True": { mousse: "N25", flawless: "N25", cream: "N15", hidef: BLOCK.DO_NOT_CODE, bb: "Dark" },
    "Deep Ebony|Olive|any": { mousse: BLOCK.NO_CODE, flawless: BLOCK.NO_CODE, cream: BLOCK.NO_CODE, hidef: BLOCK.DO_NOT_CODE, bb: "Dark" },

    "Rich Royalty|Cool/Rosy|True": { mousse: BLOCK.NO_EXACT_PRIMARY, flawless: "N45", cream: "N95", hidef: BLOCK.DO_NOT_CODE, bb: "Dark" },
    "Rich Royalty|Warm/Golden|True": { mousse: BLOCK.NO_EXACT_PRIMARY, flawless: BLOCK.NO_EXACT_PRIMARY, cream: BLOCK.NO_EXACT_PRIMARY, hidef: BLOCK.DO_NOT_CODE, bb: "Dark" },
    "Rich Royalty|Neutral|True": { mousse: BLOCK.NO_EXACT_PRIMARY, flawless: "N45", cream: "N95", hidef: BLOCK.DO_NOT_CODE, bb: "Dark" },
    "Rich Royalty|Olive|any": { mousse: BLOCK.NO_CODE, flawless: BLOCK.NO_CODE, cream: BLOCK.NO_CODE, hidef: BLOCK.DO_NOT_CODE, bb: "Dark" }
  };

  function chooseFormula(a) {
    if (a.coverage === "Light") return "bb";
    if (a.coverage === "Full" && a.skinType === "Dry") return "cream";
    if (a.skinType === "Oily" && a.finish === "Matte") return "mousse";
    if (a.coverage === "Medium") return "flawless";
    if (a.skinType === "Combination") return a.finish === "Matte" ? "mousse" : "flawless";
    return "flawless";
  }

  var CORRECTOR_MAP = {
    "Porcelain Kween": { "Dark circles": "Rose corrector", "Purple/blue circles": "Rose corrector", "Uneven skin tone": "Corrector Palette — Light" },
    "Sandy Muse": { "Dark circles": "Peachy corrector", "Purple/blue circles": "Peachy corrector", "Uneven skin tone": "Corrector Palette — Medium" },
    "Golden Glow": { "Dark circles": "Peach corrector", "Purple/blue circles": "Peach corrector", "Uneven skin tone": "Corrector Palette — Medium" },
    "Caramel Queen": { "Dark circles": "Mandarine corrector", "Purple/blue circles": "Mandarine corrector", "Uneven skin tone": "Corrector Palette — Medium Deep" },
    "Deep Ebony": { "Dark circles": "Profound Peachy corrector", "Purple/blue circles": "Profound Peachy corrector", "Uneven skin tone": "Corrector Palette — Deep" },
    "Rich Royalty": { "Dark circles": "Profound Peachy corrector", "Purple/blue circles": "Profound Peachy corrector", "Uneven skin tone": "Corrector Palette — Deep" }
  };
  var CORRECTOR_SKIP_CONCERNS = ["Shine/oil control", "Dull complexion"];

  /*var CONCEALER_MAP = {
    "Porcelain Kween": { product: "Liquid Concealer", shade: "Fair/C2" },
    "Sandy Muse": { product: "Liquid Concealer", shade: "Light/N5" },
    "Golden Glow": { product: "Liquid Concealer", shade: "Medium/N8" },
    "Caramel Queen": { product: "Liquid Concealer", shade: "Medium Deep/N10" },
    "Deep Ebony": { product: "Liquid Concealer", shade: "Deep/N25" },
    "Rich Royalty": { product: "Liquid Concealer", shade: "Rich/N45" }
  };*/

  var CONCEALER_MAP = {
  "Porcelain Kween": { product: "Cream Concealer", shade: "C3" },
  "Sandy Muse": { product: "Cream Concealer", shade: "C5" },
  "Golden Glow": { product: "Cream Concealer", shade: "C7" },
  "Caramel Queen": { product: "Cream Concealer", shade: "C10" },
  "Deep Ebony": { product: "Cream Concealer", shade: "C25" },
  "Rich Royalty": { product: "Cream Concealer", shade: "C85" }
};

  var BLUSH_MAP = {
    "Porcelain Kween": { "Natural Everyday": "Natural Kiss", "Soft Glam": "Cherry Blossom", "Boss Energy": "Cherry Blossom", "Full Glam": "Cherry Blossom" },
    "Sandy Muse": { "Natural Everyday": "Natural Kiss", "Soft Glam": "Magnolia", "Boss Energy": "Magnolia", "Full Glam": "Magnolia" },
    "Golden Glow": { "Natural Everyday": "Natural Kiss", "Soft Glam": "Abricot", "Boss Energy": "Abricot", "Full Glam": "Abricot" },
    "Caramel Queen": { "Natural Everyday": "Natural Kiss", "Soft Glam": "Rose Gold", "Boss Energy": "Rose Gold", "Full Glam": "Rose Gold" },
    "Deep Ebony": { "Natural Everyday": "Natural Kiss", "Soft Glam": "Bonbon", "Boss Energy": "Bonbon", "Full Glam": "Bonbon" },
    "Rich Royalty": { "Natural Everyday": "Natural Kiss", "Soft Glam": "Deep Skin", "Boss Energy": "Deep Skin", "Full Glam": "Deep Skin" }
  };

  var GLOW_MAP = {
    "Porcelain Kween": { "Natural Everyday": "Sheer Glo Flash", "Soft Glam": "Strobing Barbapapa", "Boss Energy": "Strobing Barbapapa", "Full Glam": "Strobing Barbapapa" },
    "Sandy Muse": { "Natural Everyday": "Sheer Glo Flash", "Soft Glam": "Sheer Glo Sweet Dream", "Boss Energy": "Strobing Beautiful Montreal", "Full Glam": "Strobing Beautiful Montreal" },
    "Golden Glow": { "Natural Everyday": "Sheer Glo Sweet Dream", "Soft Glam": "Strobing Super Star", "Boss Energy": "Summer Glow palette", "Full Glam": "Summer Glow palette" },
    "Caramel Queen": { "Natural Everyday": "Sheer Glo Nice Peach", "Soft Glam": "Strobing Sunset Beach", "Boss Energy": "Summer Glow palette", "Full Glam": "Summer Glow palette" },
    "Deep Ebony": { "Natural Everyday": "Sheer Glo Nice Peach", "Soft Glam": "Strobing Autumn", "Boss Energy": "Deep and Delicious palette", "Full Glam": "Deep and Delicious palette" },
    "Rich Royalty": { "Natural Everyday": "Sheer Glo Nice Peach", "Soft Glam": "Strobing Autumn", "Boss Energy": "Deep and Delicious palette", "Full Glam": "Deep and Delicious palette" }
  };

  var LIP_MAP = {
    "Porcelain Kween": { "Boss Matte™": "Velvet Slay", "Glossy Muse™": "Lip Gloss Nev-Rosé", "Nude Everyday": "Velvet Pink Light", "Bold Statement": "Vinyl Lacquer Unity", "Surprise Me": "Vinyl Lacquer Laughter" },
    "Sandy Muse": { "Boss Matte™": "Velvet Bubbly", "Glossy Muse™": "Lip Gloss Awake", "Nude Everyday": "Velvet Skin", "Bold Statement": "Vinyl Lacquer Sacha", "Surprise Me": "Vinyl Lacquer Kind" },
    "Golden Glow": { "Boss Matte™": "Velvet Smile", "Glossy Muse™": "Lip Gloss Ékla", "Nude Everyday": "Velvet Pozé", "Bold Statement": "Velvet Hope", "Surprise Me": "Vinyl Lacquer Compassionate" },
    "Caramel Queen": { "Boss Matte™": "Velvet Attitude", "Glossy Muse™": "Lip Gloss Narcist", "Nude Everyday": "Velvet Faith", "Bold Statement": "Velvet Kandy", "Surprise Me": "Vinyl Lacquer Josefine" },
    "Deep Ebony": { "Boss Matte™": "Velvet Scream", "Glossy Muse™": "Lip Gloss Dark Mind", "Nude Everyday": "Velvet Deep Desire", "Bold Statement": "Velvet Scarlett", "Surprise Me": "Vinyl Lacquer Hot Passion" },
    "Rich Royalty": { "Boss Matte™": "Velvet Night Out", "Glossy Muse™": "Lip Gloss Crisis", "Nude Everyday": "Velvet Money Shot", "Bold Statement": "Velvet Thunderstorm", "Surprise Me": "Vinyl Lacquer Confident" }
  };

  var COPY = { helpStates: { get shadeHelp(){return t("helpShade")}, get mappingPending(){return t("mappingPending")}, get productUnavailable(){return t("productUnavailable")} }, get routineCTA(){return t("routineCTA")} };

  /* ============================================================
   * 2) CATALOGUE — ⚠️ À REMPLIR avec tes vrais handles/variant IDs
   *    Trouve un variant ID: Admin → Produit → variante → URL,
   *    ou fetch('/products/HANDLE.js') puis regarde variants[].id
   * ============================================================ */
var CATALOG = {
  foundation: {
    "Mousse Foundation": { handle: "mousse-foundation" },
    "Flawless Foundation": { handle: "hi-def-foundation" }, // "Dewy Finish Hi-Def Foundation"
    "Cream Foundation": { handle: "cream-foundation" },
    "BB Cream": { handle: "bb-cream" }
  },
  corrector: { "Under-Eye Corrector": { handle: "under-eye-corrector" } },
 // concealer: { "Liquid Concealer": { handle: "concealer-pot" } }, // 
 concealer: { "Cream Concealer": { handle: "concealer-pot" } },
  
  blush: {
  "Natural Kiss": { handle: "blush-c" },
  "Cherry Blossom": { handle: "blush-b" },
  "Magnolia": { handle: "blush-a" },
  "Abricot": { handle: "blush-g" },
  "Rose Gold": { handle: "blush-f" },
  "Bonbon": { handle: "blush-d" },
  "Deep Skin": { handle: "blush-e" }
},
  /*blush: {
    "Natural Kiss": { handle: "blush-c" },
    "Cherry Blossom": { handle: "blush-b" },
    "Magnolia": { handle: "blush-a" },
    "Abricot": { handle: "blush-g" },
    "Rose Gold": { handle: "blush-f" },
    "Bonbon": { handle: "blush-d" },
    "Deep Skin": { handle: "blush-e" }
  },*/
 glow: {
  "Sheer Glo Flash": { handle: "sheer-glow-illuminating-lotion", key: "Flash" },
  "Sheer Glo Sweet Dream": { handle: "sheer-glow-illuminating-lotion", key: "Sweet Dream" },
  "Sheer Glo Nice Peach": { handle: "sheer-glow-illuminating-lotion", key: "Nice Peach" },
  "Strobing Barbapapa": { handle: "spot-light-strobing-d" },
  "Strobing Beautiful Montreal": { handle: "spot-light-strobing-b" },
  "Strobing Super Star": { handle: "spot-light-strobing-c" },
  "Strobing Sunset Beach": { handle: "spot-light-strobing-a" },
  "Strobing Autumn": { handle: "spot-light-strobing-e" },
  "Summer Glow palette": { handle: "eyeshadow-blush-palette-d" },
  "Deep and Delicious palette": { handle: "eyeshadow-blush-palette" }
},
  lip: {
    // ⚠️ voir note plus bas, à mapper produit par produit
  }
};

  /* ============================================================
   * 3) MOTEUR — vérif stock + résolution par catégorie
   * ============================================================ */
  function isBlocked(v) {
    return v === BLOCK.NO_CODE || v === BLOCK.DO_NOT_CODE || v === BLOCK.NO_EXACT_PRIMARY || v === BLOCK.OUT_OF_STOCK_KNOWN;
  }

  function help(kind, category) {
    return { category: category, product: null, shade: null, variant: null, variantId: null, reason: null, helpState: kind };
  }

  /* function verifyVariant(entry, key) {
    if (!entry || !entry.variantMap || !entry.variantMap[key]) {
      return Promise.resolve({ ok: false });
    }
    var variantId = entry.variantMap[key];
    return fetch(ROOT + "products/" + entry.handle + ".js")
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product) return { ok: false };
        var variant = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].id === variantId) variant = product.variants[i];
        }
        if (!variant || !variant.available) return { ok: false };
        return { ok: true, variant: variant };
      })
      .catch(function () { return { ok: false }; });
  }*/
function verifyVariant(entry, key) {
  if (!entry || !entry.handle || !key) return Promise.resolve({ ok: false });
  var needle = key.trim().toLowerCase().replace(/ corrector$/, "");
  var candidates = CANONICAL_VARIANTS[entry.handle] || [];
  var mapped = entry.variantId ? { id: entry.variantId } : candidates.find(function(v){
    var title = v.title.trim().toLowerCase();
    return title === needle || (needle === "default" && candidates.length === 1) ||
      (/^[cn]\d+$/.test(needle) && title.split(/[\s/—-]+/)[0] === needle);
  });
  if (!mapped) return Promise.resolve({ ok: false });
  return fetch(ROOT + "products/" + entry.handle + ".js")
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(product){
      if (!product) return { ok: false };
      var variant = product.variants.find(function(v){ return Number(v.id) === mapped.id && v.available; });
      if (!variant) return { ok: false };
      return { ok: true, variant: variant, product: product, url: ROOT + "products/" + entry.handle + "?variant=" + variant.id };
    }).catch(function(){ return { ok: false }; });
}

  // Exact published products for existing Mousse Foundation shade rules.
  var MOUSSE_VARIANTS = {
    "N4": {"handle":"mousse-foundation-g","variantId":43971010756921},
    "N5": {"handle":"mousse-foundation-h","variantId":43971010396473},
    "N7": {"handle":"mousse-foundation-i","variantId":43971009020217},
    "N9": {"handle":"mousse-foundation-j","variantId":43971008364857},
    "N25": {"handle":"mousse-foundation-f","variantId":43971012755769},
    "C2": {"handle":"mousse-foundation-a","variantId":43971021799737},
    "C4": {"handle":"mousse-foundation-c","variantId":43971017081145},
    "C6": {"handle":"mousse-foundation-d","variantId":43971015999801}
  };
  var FLAWLESS_VARIANTS = {"C9":{"handle":"face-foundation-flawless-finish-j","variantId":43970811527481},"C10":{"handle":"face-foundation-flawless-finish-k","variantId":43970986737977},"C2":{"handle":"face-foundation-flawless-finish-a","variantId":43970988409145},"C25":{"handle":"face-foundation-flawless-finish-b","variantId":43970995159353},"C3":{"handle":"face-foundation-flawless-finish-c","variantId":43970995421497},"C4":{"handle":"face-foundation-flawless-finish-d","variantId":43970996732217},"C5":{"handle":"defaut-face-foundation-flawless-finish-e","variantId":43970997256505},"C6":{"handle":"defaut-face-foundation-flawless-finish-f","variantId":43970997354809},"C7":{"handle":"defaut-face-foundation-flawless-finish-g","variantId":43970998010169},"C8":{"handle":"face-foundation-flawless-finish-h","variantId":43970998599993},"N9":{"handle":"face-foundation-flawless-finish-s","variantId":43971054666041},"N8":{"handle":"face-foundation-flawless-finish-r","variantId":43971054960953},"N7":{"handle":"face-foundation-flawless-finish-q","variantId":43971057779001},"N5":{"handle":"face-foundation-flawless-finish-p","variantId":43971058565433},"N45":{"handle":"face-foundation-flawless-finish-o","variantId":43971061219641},"N3":{"handle":"face-foundation-flawless-finish-n","variantId":43971062333753},"N25":{"handle":"face-foundation-flawless-finish-m","variantId":43971065315641},"N2":{"handle":"face-foundation-flawless-finish-l","variantId":43971066429753},"N10":{"handle":"face-foundation-flawless-finish-t","variantId":43971067412793},"C85":{"handle":"face-foundation-flawless-finish-i","variantId":43971068330297}};
  CANONICAL_VARIANTS["colour-corrector-palette"] = [{"id":50110503485753,"title":"Light"},{"id":50110503518521,"title":"Medium"},{"id":50110503551289,"title":"Medium Deep"},{"id":50110503584057,"title":"Deep"}];

  function resolveFoundation(a) {
    if (a.undertone === "Olive") return Promise.resolve(help(COPY.helpStates.shadeHelp, "foundation"));
    var row = PRIMARY_SHADE_MAP[a.vFamily + "|" + a.undertone + "|" + a.subDepth] || PRIMARY_SHADE_MAP[a.vFamily + "|" + a.undertone + "|True"];
    if (!row) return Promise.resolve(help(COPY.helpStates.shadeHelp, "foundation"));
    var formulaKey = chooseFormula(a);
    var candidate = row[formulaKey];
    if (isBlocked(candidate)) return Promise.resolve(help(COPY.helpStates.shadeHelp, "foundation"));
    var names = { mousse: "Mousse Foundation", flawless: "Flawless Foundation", cream: "Cream Foundation", bb: "BB Cream" };
    var productName = names[formulaKey];
    var entry = formulaKey === "flawless" ? FLAWLESS_VARIANTS[candidate] : formulaKey === "mousse" ? (MOUSSE_VARIANTS[candidate] || CATALOG.foundation[productName]) : CATALOG.foundation[productName];
    return verifyVariant(entry, candidate).then(function (check) {
      if (!check.ok) return help(COPY.helpStates.productUnavailable, "foundation");
      return {
        category: "foundation", product: productName, shade: candidate, variantId: check.variant.id, url: check.url,
         image: (check.variant.featured_image && check.variant.featured_image.src) || check.product.featured_image,
        reason: "Your " + a.vFamily + " complexion, " + a.undertone.toLowerCase() + " undertone, " + a.skinType.toLowerCase() + " skin and " + a.coverage.toLowerCase() + " coverage preference make this your strongest V-Match.",
        helpState: null
      };
    });
  }




  function resolveCorrector(a) {
    if (CORRECTOR_SKIP_CONCERNS.indexOf(a.beautyConcern) !== -1) {
      return Promise.resolve({ category: "corrector", product: null, helpState: null, skipped: true });
    }
    var row = CORRECTOR_MAP[a.vFamily];
    var variantName = row && row[a.beautyConcern];
    if (!variantName) return Promise.resolve(help(COPY.helpStates.mappingPending, "corrector"));
    var isPalette = variantName.indexOf("Corrector Palette — ") === 0;
    var entry = isPalette ? { handle: "colour-corrector-palette" } : CATALOG.corrector["Under-Eye Corrector"];
    var shade = isPalette ? variantName.replace("Corrector Palette — ", "") : variantName;
    return verifyVariant(entry, shade).then(function (check) {
      if (!check.ok) return help(COPY.helpStates.mappingPending, "corrector");
      return { 
          category: "corrector", product: check.product.title, shade: shade, variantId: check.variant.id, url: check.url, 
         image: (check.variant.featured_image && check.variant.featured_image.src) || check.product.featured_image,
        reason: "Your selected concern and " + a.vFamily + " family make this the mapped primary corrector.", helpState: null };
    });
  }

  function resolveConcealer(a) {
    var entry = CONCEALER_MAP[a.vFamily];
    if (!entry) return Promise.resolve(help(COPY.helpStates.mappingPending, "concealer"));
    return verifyVariant(CATALOG.concealer[entry.product], entry.shade).then(function (check) {
      if (!check.ok) return help(COPY.helpStates.mappingPending, "concealer");
      return { category: "concealer", product: entry.product, shade: entry.shade, variantId: check.variant.id, url: check.url, 
         image: (check.variant.featured_image && check.variant.featured_image.src) || check.product.featured_image,
        reason: "This is the mapped same-skin complexion match for your family.", helpState: null };
    });
  }

  function resolveBlush(a) {
    var product = BLUSH_MAP[a.vFamily] && BLUSH_MAP[a.vFamily][a.beautyStyle];
    if (!product) return Promise.resolve(help(COPY.helpStates.mappingPending, "blush"));
    return verifyVariant(CATALOG.blush[product], "default").then(function (check) {
      if (!check.ok) return help(COPY.helpStates.mappingPending, "blush");
      return { category: "blush", product: product, variantId: check.variant.id, url: check.url,
         image: (check.variant.featured_image && check.variant.featured_image.src) || check.product.featured_image,
        reason: "Your " + a.vFamily + " family and " + a.beautyStyle + " style map to this primary blush.", helpState: null };
    });
  }

 function resolveGlow(a) {
  var product = GLOW_MAP[a.vFamily] && GLOW_MAP[a.vFamily][a.beautyStyle];
  var entry = product && CATALOG.glow[product];
  if (!entry) return Promise.resolve(help(COPY.helpStates.mappingPending, "glow"));
  return verifyVariant(entry, entry.key || "default").then(function (check) {
    if (!check.ok) return help(COPY.helpStates.mappingPending, "glow");
    return {
      category: "glow", product: check.product.title, variantId: check.variant.id, url: check.url,
      image: (check.variant.featured_image && check.variant.featured_image.src) || check.product.featured_image,
      reason: "Your family and " + a.beautyStyle + " style map to the strongest listed glow primary.",
      helpState: null
    };
  });
}

  var LIP_CATALOG = {
  "Velvet": { handle: "creamy-liquid-lipstick" },
  "Lip Gloss": { handle: "long-lasting-lipgloss" },
  "Vinyl Lacquer": { handle: "intense-lacquer" }
};

function resolveLip(a) {
  var shadeFull = LIP_MAP[a.vFamily] && LIP_MAP[a.vFamily][a.lipPreference];
  if (!shadeFull) return Promise.resolve(help(COPY.helpStates.productUnavailable, "lip"));

  var prefix = Object.keys(LIP_CATALOG).find(function (p) { return shadeFull.indexOf(p) === 0; });
  if (!prefix) return Promise.resolve(help(COPY.helpStates.productUnavailable, "lip"));

  var shadeName = shadeFull.replace(prefix, "").trim(); // ex: "Velvet Slay" -> "Slay"
  return verifyVariant(LIP_CATALOG[prefix], shadeName).then(function (check) {
    if (!check.ok) return help(COPY.helpStates.productUnavailable, "lip");
    return {
      category: "lip", product: check.product.title, shade: shadeName,
      variantId: check.variant.id, url: check.url,
      image: (check.variant.featured_image && check.variant.featured_image.src) || check.product.featured_image,
      reason: "Your " + a.lipPreference + " preference and " + a.vFamily + " family map to this primary lip.",
      helpState: null
    };
  });
}
  /*function resolveLip(a) {
    var shade = LIP_MAP[a.vFamily] && LIP_MAP[a.vFamily][a.lipPreference];
    if (!shade) return Promise.resolve(help(COPY.helpStates.productUnavailable, "lip"));
    return verifyVariant(CATALOG.lip["Lip Product"], shade).then(function (check) {
      if (!check.ok) return help(COPY.helpStates.productUnavailable, "lip");
      return { category: "lip", product: "Lip Product", shade: shade, variantId: check.variant.id, url: check.url, reason: "Your " + a.lipPreference + " preference and " + a.vFamily + " family map to this primary lip.", helpState: null };
    });
  }*/

  function resolveKit(a, r) {
    var allActive = Object.keys(r).every(function (k) { return r[k].helpState === null || r[k].skipped; });
    if (!allActive) return "Essential";
    if (a.beautyStyle === "Full Glam" || a.coverage === "Full") return "Ultimate V-Glow";
    return "Power Glow";
  }

  function computeVGlowResult(answers) {
    return Promise.all([
      resolveFoundation(answers), resolveCorrector(answers), resolveConcealer(answers),
      resolveBlush(answers), resolveGlow(answers), resolveLip(answers)
    ]).then(function (arr) {
      var r = { foundation: arr[0], corrector: arr[1], concealer: arr[2], blush: arr[3], glow: arr[4], lip: arr[5] };
      return {
        profile: answers.vFamily,
        beautyDNA: {
          skinTone: answers.vFamily, undertone: answers.undertone, oliveRefinement: answers.oliveRefinement || null,
          skinType: answers.skinType, coverage: answers.coverage, beautyConcern: answers.beautyConcern,
          beautyStyle: answers.beautyStyle, lipPreference: answers.lipPreference
        },
        foundationMatch: r.foundation, correctorMatch: r.corrector, concealerMatch: r.concealer,
        blushMatch: r.blush, glowMatch: r.glow, lipMatch: r.lip,
        kit: resolveKit(answers, r),
        stockStatus: Object.keys(r).every(function (k) { return r[k].helpState === null; }) ? "all mapped variants available" : "partial"
      };
    });
  }

  /* ============================================================
   * 4) UI — state machine du quiz (7 écrans + micro-question Olive)
   * ============================================================ */
  var QUESTIONS = [
    {
  key: "vFamily",
  title: "WHICH FAMILY FEELS CLOSEST TO YOU?",
  options: [
    {
      title: "Porcelain Kween",
      description: "Very fair skin, often with freckles or pink undertones",
      image: "https://cdn.shopify.com/s/files/1/0014/9749/7675/files/quiz-THE_V_QUIZ_GLOW_f-1.webp?v=1782736268&width=352.00000524520874&height=352.00000524520874"
    },
    {
      title: "Sandy Muse",
      description: " Light to medium skin, sand/neutral beige complexion ",
      image: "https://cdn.shopify.com/s/files/1/0014/9749/7675/files/quiz-THE_V_QUIZ_GLOW_f-2.webp?v=1782736299&width=352.00000524520874&height=352.00000524520874"
    },
    {
      title: "Golden Glow",
      description: "Olive or golden skin, bronze easily",
      image: "https://cdn.shopify.com/s/files/1/0014/9749/7675/files/quiz-THE_V_QUIZ_GLOW_f-3.webp?v=1782736320&width=352.00000524520874&height=352.00000524520874"
    },
    {
      title: "Caramel Queen",
      description: "Caramel skin, light black, mixed or Indian skin, warm undertones",
      image: "https://cdn.shopify.com/s/files/1/0014/9749/7675/files/quiz-THE_V_QUIZ_GLOW_f-4.webp?v=1782736341&width=352.00000524520874&height=352.00000524520874"
    },
    {
      title: "Deep Ebony",
      description: "Dark, rich, chocolate skin, caramel, light black, mixed or Indian skin, warm undertones   ",
      image: "https://cdn.shopify.com/s/files/1/0014/9749/7675/files/quiz-THE_V_QUIZ_GLOW_f-5.webp?v=1782736372&width=352.00000524520874&height=352.00000524520874"
    },
    {
      title: "Rich Royalty",
      description: " Very deep skin, pure ebony with cold or neutral undertones",
      image: "https://cdn.shopify.com/s/files/1/0014/9749/7675/files/quiz-THE_V_QUIZ_GLOW_f-6.webp?v=1782736395&width=352.00000524520874&height=352.00000524520874"
    }
  ]
},
    //{ key: "vFamily", title: "WHICH FAMILY FEELS CLOSEST TO YOU?", options: ["Porcelain Kween", "Sandy Muse", "Golden Glow", "Caramel Queen", "Deep Ebony", "Rich Royalty"] },
    { key: "undertone", title: "WHAT'S YOUR UNDERTONE?", options: ["Cool/Rosy", "Warm/Golden", "Neutral", "Olive", "I'm Not Sure"] },
    { key: "subDepth", title: "HOW DEEP IS YOUR SHADE?", options: ["Light", "True", "Deeper"] },
    { key: "skinType", title: "WHAT'S YOUR SKIN TYPE?", options: ["Dry", "Oily", "Combination", "Normal"] },
    { key: "coverage", title: "HOW MUCH COVERAGE DO YOU WANT?", options: ["Light", "Medium", "Full"] },
    { key: "finish", title: "WHAT FINISH DO YOU PREFER?", options: ["Natural", "Radiant", "Satin", "Soft Matte", "Matte"] },
    { key: "beautyConcern", title: "WHAT'S YOUR MAIN BEAUTY CONCERN?", options: ["Dark circles", "Dull complexion", "Imperfections", "Uneven skin tone", "Shine/oil control", "Full glow-up"] },
    { key: "beautyStyle", title: "WHAT'S YOUR BEAUTY STYLE?", options: ["Natural Everyday", "Soft Glam", "Boss Energy", "Full Glam", "NOT SURE — GUIDE ME"] },
    { key: "lipPreference", title: "WHAT'S YOUR LIP PREFERENCE?", options: ["Boss Matte™", "Glossy Muse™", "Nude Everyday", "Bold Statement", "Surprise Me"] }
  ];
  var OLIVE_QUESTION = {
    key: "oliveRefinement",
    title: t("oliveTitle"),
    sub: t("oliveSub"),
    options: [
      { value: "GOLDEN OLIVE", label: t("oliveGolden") },
      { value: "NEUTRAL OLIVE", label: t("oliveNeutral") },
      { value: "I'M NOT SURE", label: t("oliveSure") }
    ]
  };

  function initVGlowQuiz(root) {
    var answers = {};
    var flow = QUESTIONS.slice();
    var stepIndex = 0;

    function currentFlow() {
      // insère la micro-question Olive juste après "undertone" si besoin
      var f = QUESTIONS.slice();
      if (answers.undertone === "Olive") {
        var idx = f.findIndex(function (q) { return q.key === "undertone"; });
        f.splice(idx + 1, 0, OLIVE_QUESTION);
      }
      return f;
    }

function renderQuestion() {
  var f = currentFlow();
  var q = f[stepIndex];

  if (!q) {
    renderEmailGate();
    return;
  }

  var total = f.length;

  var optsHtml = (q.options || []).map(function (opt) {
    var isObject = typeof opt === "object";

    var value = isObject ? (opt.value || opt.title) : opt;
    var label = isObject ? (opt.label || opt.title) : opt;
    var displayLabel = LANG === "fr" && q.key === "subDepth" && label === "Light" ? "Claire" : display(label);
    var description = isObject ? (opt.description || "") : "";
    var image = isObject ? (opt.image || "") : "";

    var isSelected = answers[q.key] === value;

    return (
      '<button class="vglow-option' +
      (isSelected ? " vglow-option-selected" : "") +
      '" data-value="' +
      value.replace(/"/g, "&quot;") +
      '">' +

      (image
        ? '<img class="vglow-option-image" src="' +
          image +
          '" alt="' +
          displayLabel.replace(/"/g, "&quot;") +
          '" loading="lazy">'
        : "") +

      '<span class="vglow-option-content">' +
        '<span class="vglow-option-title">' +
          displayLabel +
        '</span>' +

        (description
          ? '<span class="vglow-option-description">' +
              display(description) +
            '</span>'
          : "") +

      '</span>' +

      "</button>"
    );
  }).join("");

  var backBtnHtml = stepIndex > 0
    ? '<button class="vglow-back" id="vglow-back-btn">' + t("back") + '</button>'
    : "";

  root.innerHTML =
    '<div class="vglow-progress">' + t("progress", {n:stepIndex+1,total:total}) + '</div>' +

    '<p class="vglow-microcopy">' +
      (stepIndex < total - 1
        ? t("closer")
        : t("almost")) +
    "</p>" +

    '<h2 class="vglow-title" tabindex="-1">' +
      display(q.title) +
    "</h2>" +

    (q.sub
      ? '<p class="vglow-sub">' + display(q.sub) + "</p>"
      : "") +

    '<div class="vglow-options">' +
      optsHtml +
    "</div>" +

    backBtnHtml;
  
  root.querySelector(".vglow-title").focus({preventScroll:true});
  root.querySelectorAll(".vglow-option").forEach(function (btn) {
    btn.addEventListener("click", function () {
      answers[q.key] = btn.getAttribute("data-value");
      stepIndex++;
      renderQuestion();
    });
  });

  if (stepIndex > 0) {
    root.querySelector("#vglow-back-btn").addEventListener("click", function () {
      stepIndex--;
      renderQuestion();
    });
  }

  
}

function renderEmailGate() {
  root.innerHTML =
    '<h2 class="vglow-title" tabindex="-1">' + t("emailTitle") + '</h2>' +
    '<p class="vglow-sub">' + t("emailText") + '</p>' +
    '<form class="vglow-email-form"><label for="vglow-optin-email">' + t("emailLabel") + '</label>' +
    '<input id="vglow-optin-email" type="email" name="email" placeholder="' + t("placeholder") + '" class="vglow-input" />' +
    '<label class="vglow-consent"><input type="checkbox" name="consent" /> ' + t("consent") + '</label>' +
    '<p><a href="' + ROOT + 'pages/privacy-policy">' + t("privacy") + '</a></p>' +
    '<button type="submit" class="vglow-cta">' + t("reveal") + '</button></form>' +
    '<button class="vglow-back" id="vglow-back-btn">' + t("back") + '</button>';
  var gate = root.querySelector(".vglow-email-form");
  gate.elements.consent.addEventListener("change", function() { gate.elements.email.required = this.checked; });
  gate.addEventListener("submit", function (e) {
    e.preventDefault();
    if (gate.elements.consent.checked && gate.elements.email.value) {
      submitEmailToShopify(gate.elements.email.value, answers.vFamily);
    }
    renderTransition();
  });
  root.querySelector("#vglow-back-btn").addEventListener("click", function () {
    stepIndex = currentFlow().length - 1;
    renderQuestion();
  });
}
function submitEmailToShopify(email, vFamily) {
  var form = document.getElementById("vglow-shopify-customer-form");
  if (!form) return;
  document.getElementById("vglow-customer-email").value = email;
  document.getElementById("vglow-customer-tags").value = ["v-glow-quiz", vFamily].filter(Boolean).join(",");
  form.querySelector('[name="contact[accepts_marketing]"]').value = "true";
  form.target = "vglow-hidden-iframe";
  form.requestSubmit();
}
    function renderTransition() {
      root.innerHTML =
        '<h2 class="vglow-title" tabindex="-1">' + t("creating") + '</h2>' +
        '<ul class="vglow-checklist">' +
        '<li>' + t("matching") + '</li><li>' + t("reading") + '</li>' +
        '<li>' + t("goals") + '</li><li>' + t("routine") + '</li>' +
        "</ul>";
      computeVGlowResult(answers).then(function (result) {
        renderResult(result);
      }).catch(function(){ root.innerHTML = '<p role="alert">' + t("retry") + '</p><button class="vglow-back" id="vglow-retry">' + t("reveal") + '</button>'; root.querySelector("#vglow-retry").addEventListener("click", renderTransition); });
    }

      function line(match) {
  if (!match || match.skipped) return "";
  if (match.helpState) return '<div class="vglow-result-line vglow-help">' + match.helpState + ' <a href="' + ROOT + 'pages/contact-us">' + t("helpShade") + '</a></div>';
  //var shadeTxt = match.shade ? " — " + match.shade : match.variant ? " — " + match.variant.title : "";
  var shadeTxt = match.shade ? " — " + match.shade : "";
  var imgHtml = match.image
    ? '<img class="vglow-product-img" src="' + match.image + '" alt="' + match.product + '" width="80" height="80" loading="lazy">'
    : "";
  return (
    '<div class="vglow-result-line">' +
    imgHtml +
    '<div class="vglow-result-info">' +
    "<strong>" + match.product + shadeTxt + "</strong>" +
    '<p class="vglow-reason">' + t("reason") + "</p>" +
    (match.url ? '<p><a href="' + match.url + '">' + t("details") + '</a></p>' : "") +
    '<button class="vglow-add-single" data-variant-id="' + match.variantId + '">' + t("add") + '</button>' +
    "</div>" +
    "</div>"
  );
}

    function renderResult(result) {
      var addableIds = [result.foundationMatch, result.correctorMatch, result.concealerMatch, result.blushMatch, result.glowMatch, result.lipMatch]
        .filter(function (m) { return m && m.helpState === null && m.variantId; })
        .map(function (m) { return { id: m.variantId, quantity: 1 }; });

      root.innerHTML =
        '<h2 class="vglow-title" tabindex="-1">' + t("profile") + '</h2>' +
        '<h3 class="vglow-family">' + t("family", {profile: result.profile.toUpperCase()}) + '</h3>' +
        '<h4>' + t("foundation") + '</h4>' + line(result.foundationMatch) +
        '<h4>' + t("corrector") + '</h4>' + line(result.correctorMatch) +
        '<h4>' + t("concealer") + '</h4>' + line(result.concealerMatch) +
        '<h4>' + t("blush") + '</h4>' + line(result.blushMatch) +
        '<h4>' + t("glow") + '</h4>' + line(result.glowMatch) +
        '<h4>' + t("lip") + '</h4>' + line(result.lipMatch) +
        '<p class="vglow-kit">' + t("kit") + ' <strong>' + result.kit + "</strong></p>" +
        '<div class="vglow-offer-card">' +
          '<p class="vglow-offer-label">' + t("offer") + '</p>' +
          '<h3 class="vglow-offer-headline">' + t("headline") + '</h3>' +
          '<button class="vglow-cta" id="vglow-add-cart"><span class="vglow-cta-text">' + COPY.routineCTA + '</span></button>' +
          '<p class="vglow-offer-footer">' + t("footer") + '</p>' +
        '</div>';

  
root.querySelectorAll(".vglow-add-single").forEach(function (btn) {
  btn.addEventListener("click", function () {
    btn.disabled = true;
    btn.textContent = t("adding");
    fetch(ROOT + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart");
      window.location.href = ROOT + "cart";
    }).catch(function () { btn.textContent = t("error"); btn.disabled = false; });
  });
});
      var routineBtn = root.querySelector("#vglow-add-cart");
      routineBtn.disabled = !addableIds.length;
      routineBtn.addEventListener("click", function () {
        if (!addableIds.length) return;
        routineBtn.disabled = true;
        routineBtn.textContent = t("adding");
        fetch(ROOT + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: addableIds })
        }).then(function (r) {
          if (!r.ok) throw new Error("cart");
          window.location.href = ROOT + "cart";
        }).catch(function () { routineBtn.textContent = t("error"); routineBtn.disabled = false; });
      });
      var restart = document.createElement("button");
      restart.type = "button"; restart.className = "vglow-back"; restart.textContent = t("restart");
      restart.addEventListener("click", function(){ answers = {}; stepIndex = 0; renderQuestion(); });
      root.appendChild(restart);
    }
    renderQuestion();
  }
  window.VGlowQuiz = { init: initVGlowQuiz, computeVGlowResult: computeVGlowResult, CATALOG: CATALOG };
})();

